export default {
  title: 'Roles',
  add: 'Nuevo Rol',
  ingreso: 'Ingresos',
  list: {
    title: 'Roles',
    columns: {
      name: 'Nombre Rol',
      actions: 'Acciones',
    },
  },
  create: {
    customer: 'Cliente *',
    contact: 'Contacto *',
    noContacts: 'Cliente no tiene contactos',
    file: 'Archivo *',
    number: 'Nro de presupuesto *',
    description: 'Descripción',
    state: 'Estado',
    save: 'Crear',
    list: 'Volver a la lista',
    success: 'Rol creado exitosamente',
    error: 'Algo succedió mal',
    subtitle: 'Creación nuevo Rol',
  },
  edit: {
    contact: 'Contacto *',
    noContacts: 'Cliente no tiene contactos',
    file: 'Archivo *',
    fileBkp: 'Respaldo de aprobación *',
    number: 'Nro de presupuesto *',
    description: 'Descripción',
    solicitud: 'Solicitud',
    state: 'Estado',
    save: 'Guardar',
    list: 'Volver a la lista',
    comment: 'Comentario del cambio de estado',
    subtitleData: 'Datos del presupuesto',
    success: 'Presupuesto editado exitosamente',
  },
};
